export const InfoFormStrings = {
  other:
    'If you selected "Other", you may provide additional information if desired:',
  1: {
    question: '1. Gender:',
    answers: ['Male', 'Female', 'Other', 'Prefer Not to Say'],
  },
  2: {
    question: '2. Ethnicity:',
    answers: [
      'Hispanic or Latino',
      'Not Hispanic or Latino',
      'Other',
      'Prefer Not to Say',
    ],
  },
  3: {
    question: '3. Race:',
    answers: [
      'American Indian',
      'Alaska Native',
      'Asian',
      'Black or African American',
      'More Than One Race',
      'Native Hawaiian or Other Pacific Islander',
      'White or European',
      'Unknown',
      'Other',
      'Prefer Not to Say',
    ],
    otherText:
      'If you selected "More Than One Race, Unknown, or Other", you may provide additional information if desired:',
  },
  4: {
    question: '4. Highest Level of Education Completed:',
    answers: [
      'High School',
      'GED or High School Diploma',
      'Trade or Technical School',
      'Some College',
      'Associate’s Degree',
      'Bachelor’s Degree',
      'Master’s Degree',
      'Doctoral Degree',
      'Other',
      'Prefer Not to Say',
    ],
  },
  5: {
    question:
      '5. First Language(s) Learned - If more than one language learned simultaneously, separate with ; when listing:',
  },
  6: {
    question:
      '6. If English was not your first language, are you fluent in English?',
    answers: ['Yes', 'No', 'Somewhat', 'Prefer Not to Say'],
    otherText:
      'If you selected "No" or "Somewhat", you may provide additional information if desired:',
  },
  7: {
    question: '7. Do you currently have any hearing difficulties?',
    answers: ['Yes', 'No', 'Somewhat', 'Prefer Not to Say'],
    otherText: 'If you currently have hearing difficulties, please describe:',
  },
  8: {
    question: '8. Vision (check all that apply):',
    answers: [
      '20/20 Vision - Do Not Need Glasses or Contacts',
      'Assisted Vision - Require Glasses or Contacts',
      'Change in Color Vision - Inability to see colors or distinguish shades and tint of color',
      'Other',
      'Prefer Not to Say',
    ],
    otherText:
      'If you selected "Change in Color Vision", "Other", or if you currently have vision difficulties, you may provide additional information if desired:',
  },
  9: {
    question:
      '9. If you selected "Assisted Vision", will you be wearing your glasses or contacts for your online or onsite session?',
    answers: ['Yes', 'No', 'Prefer Not to Say'],
    otherText:
      'If you selected "No", you may provide additional information if desired:',
  },
  10: {
    question:
      '10. Have you taken any medication that could potentially affect your ability to perform a memory-based task?',
    answers: ['Yes', 'No', 'Prefer Not to Say'],
    otherText:
      'If yes, please explain HOW the medication may effect your expression, affect, movement, mood, speech, vision, hearing, concentration or participation. We are not asking for the name or dosage of medication(s).',
  },
}
